// extracted by mini-css-extract-plugin
module.exports = {"spoilerButton":"style_spoiler-button__kgeK1","spoilerArrow":"style_spoiler-arrow__k06AW","spoilerOpen":"style_spoiler-open__Et0Q7","spoilerContent":"style_spoiler-content__bTCFQ"};